import React from 'react';
import { Document, Page, StyleSheet, View, Text, Image, Font, Link } from '@react-pdf/renderer';
import ProximaNovaRegular from '../../../../Assets/font/proximanova_regular.ttf';
import ProximaNovaBold from '../../../../Assets/font/ProximaNova-Bold.ttf';
import ProximaNovaThin from '../../../../Assets/font/FontsFree-Net-Proxima-Nova-Thin.ttf';
import ProximaNovalight from '../../../../Assets/font/proximanova_light.ttf';
import Proxima_Nova_Semibold from '../../../../Assets/font/fonnts.com-Proxima_Nova_Semibold.ttf';
// import logo from "../../assets/image/LogoTagline.png";
// import attachments_img from "../../assets/image/attachments.png"
// import ellips_img from "../../assets/image/Ellipse 1.png";
// import InstaIcons from "../../assets/image/icons.png";
// import sendIcons from "../../assets/image/send.png";
// import callIcons from "../../assets/image/call.png";
import logo from "Assets/images/logo.png";
import InstaIcons from "Assets/images/reportIntaIcon.png"
import callIcons from "Assets/images/reportPhoneIcon.png"
import attachments_img from "Assets/images/AttachmentIcon.png"
import ellips_img from "Assets/images/AttachmentIcon.png"
import clickIcon from "Assets/images/reportClickIcon.png"
import { ClientDetailsPdf } from "./Components/ClientDetails";
import { ASSESSMENT_REPORT_V2_QUESTIONS, extractUploadFileName, INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS, reportDateFormat, TREATMENT_SUMMARY_REPORT_V2_QUESTIONS } from "config/constants";
import { RenderAnswerByQId } from "./Components/AnswerFields/Index";
import GoalReviewSection from "./Components/GoalReviewSection";
import TherapistSignaturePdf from "./Components/TherapistSignature";
import Html from "react-pdf-html";
import { dateFormat, isValidValue } from "helpers/common";
import ObservationsSection from './Components/ObservationsSection';
import { PdfFooter } from './Components/PdfFooter';
import AnswerMultipleRecommendations from './Components/AnswerFields/AnswerMultipleRecommendations';
import AnswerEditor from './Components/AnswerFields/AnswerEditor';
import { Table, TD, TH, TR } from '@ag-media/react-pdf-table';
import TreatmentPlanSection from './Components/TreatmentPlanSection';
import ProximaNovaRegularItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Reg-It.otf';
import ProximaNovaThinItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Thin-It.otf';
import ProximaNovaBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaBoldItalic.ttf';
import ProximaNovaSemiBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaSemiboldItalic.ttf';
import ProximaNovaLightItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Light-It.otf';
import PDFHtmlRenderer from "./Components/PDFHtmlRenderer";
import AssessmentTableDataPDF from "./Components/AssessmentTableDataPDF";
import TreatmentSummarySection from './Components/TreatmentSummarySection';

Font.register({
    family: 'Proxima Nova',
    fonts: [
        { src: ProximaNovaThin, fontWeight: 100 },         // thin
        { src: ProximaNovalight, fontWeight: 300 },        // light
        { src: ProximaNovaRegular, fontWeight: 400 },      // normal
        { src: Proxima_Nova_Semibold, fontWeight: 600 },   // semibold
        { src: ProximaNovaBold, fontWeight: 700 },         // bold
        { src: ProximaNovaThinItalic, fontWeight: 'thin', fontStyle: 'italic' },
        { src: ProximaNovaLightItalic, fontWeight: 'light', fontStyle: 'italic' },
        { src: ProximaNovaRegularItalic, fontWeight: 'normal', fontStyle: 'italic' },
        { src: ProximaNovaSemiBoldItalic, fontWeight: 'semibold', fontStyle: 'italic' },
        { src: ProximaNovaBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
    ],
});


const styles = StyleSheet.create({
    page: {
        color: "#000",
        padding: 20,
        backgroundColor: '#ffffff',
        fontFamily: 'Proxima Nova',
        paddingTop: 20,
        paddingBottom: 80,
    },
    container: {
        padding: '0 40px 0 40px',
    },
    pageNumber: {
        textAlign: "right",
        paddingBottom: 10,
        // position: "absolute",
        // right: "10%"
    },
    fontBold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'bold'
    },
    fontSemibold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'semibold'
    },
    fontLight: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'light'
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "flex-end",
        marginBottom: 20,
        padding: '0 40px 0 0',
    },
    logo: {
        width: 127,
    },
    headerTitle: {
        fontSize: 9,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginTop: 5,
        color: "#93278F"
    },
    border: {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        marginBottom: "8px"
    },
    mainHeading: {
        fontSize: 10,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
    },
    mainSubHeading: {
        fontSize: 8,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
        letterSpacing: "1px",
        textTransform: "uppercase"
    },
    subHeading: {
        fontSize: 7,
        fontWeight: 'semibold',
    },
    para: {
        fontSize: 11,
        fontWeight: 'normal',
        lineHeight: "13px"
    },
    clientSubInfo: {
        fontSize: 10,
    },
    flex: {
        display: "flex",
        flexDirection: "row"
    },
    halfCol: {
        width: '50%',
    },
    mainSubHeadingWithOutSpacing: {
        fontSize: 8,
        fontWeight: 'thin',
        fontFamily: 'Proxima Nova',
        textTransform: "uppercase",
        color: "#000"
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        fontSize: 10,
        // color: 'grey',
        padding: '0px 60px 0px 60px',
        // marginTop: "10px",
        marginBottom: "-10px",
    },
    link: {
        fontSize: 7,
        color: "#000",
        fontFamily: 'Proxima Nova',
        fontWeight: 'light',
        // borderBottom: "1px solid #333"
    }
});

const TreatmentSummaryReportDocV2 = ({ data }) => {
    const reportQuestions = data?.reportQuestions;
    const reportAnswers = data?.reportAnswers;
    const reportRecommendations = data?.recommendation;
    const assessmentPlans = data?.assessmentPlans;
    const treatmentPlans = data?.treatmentPlans;
    const treatmentSummary = data?.treatmentSummary;
    const feedbacks = data?.feedbacks;

    console.log('data feedbacks', data)
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    <View
                        style={styles.pageNumber}
                        render={({ pageNumber, totalPages }) => (
                            <Text style={{ ...styles.para }}>Page {pageNumber}/{totalPages}</Text>
                        )}
                        fixed
                    ></View>
                    <View style={styles.headerRow}>
                        <View>
                            <Image style={styles.logo} src={logo} />
                        </View>
                        <View>
                            <Text style={[styles.headerTitle, { ...styles.fontBold, letterSpacing: "1px", textTransform: "uppercase" }]}>{data?.therapist?.therapist_discipline?.name}</Text>
                            <Text style={styles.subtitle}>Treatment Summary Report</Text>
                        </View>
                        <View>
                            <Text style={[styles.fontSemibold, { fontSize: 7, alignContent: "flex-end" }]}>REPORT DATE</Text>
                            <Text style={{ ...styles.para, alignContent: "flex-end", marginTop: "3px" }}>{data?.screening_date}</Text>
                        </View>
                    </View>

                    <View style={styles.container}>
                        <View style={styles.border}>
                            <Text style={{ ...styles.mainHeading }}>CLIENT INFORMATION</Text>
                        </View>
                        <View style={{ ...styles.flex, justifyContent: "space-between" }}>
                            <ClientDetailsPdf
                                data={data}
                                styles={styles}
                            />
                        </View>

                        <View style={{ ...styles.border, marginTop: "15px" }}>
                            <Text style={{ ...styles.mainHeading, fontSize: 10 }}>SCHOOL INFORMATION</Text>
                        </View>
                        <View>
                            {/* TEACHER SECTION */}
                            {data?.selectedGuardians?.length > 0 && data?.selectedGuardians
                                ?.sort((a, b) => {
                                    console.log('a and b', a, b)
                                    if (a?.key === "teacher") return -1; // a comes first
                                    if (b?.key === "teacher") return 1;  // b comes first
                                    return 0; // order unchanged for teacher
                                })
                                ?.map((item) => (
                                    <View style={{ marginBottom: "10px" }}>
                                        <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px" }}>
                                            <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>{item.key}</Text>
                                        </View>
                                        <View style={{ ...styles.flex, justifyContent: "space-between", marginBottom: 5 }}>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>LAST NAME</Text>
                                                <Text style={{ ...styles.para, fontSize: 9 }}>{item?.client_guardian?.lastname}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>FIRST NAME</Text>
                                                <Text style={{ ...styles.para, fontSize: 9 }}>{item?.client_guardian?.firstname}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>EMAIL</Text>
                                                <Text style={{ ...styles.para, fontSize: 9 }}>{item?.client_guardian?.email}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>CITY/TOWN</Text>
                                                <Text style={styles.para}>{item.client_guardian?.client_role?.slug != "teahcer" ? data?.schoolLocation : item?.city}</Text>
                                            </View>
                                            {
                                                item.client_guardian?.client_role?.slug != "parent" &&
                                                <View style={{ gap: "3px" }}>
                                                    <Text style={styles.subHeading}>SCHOOL</Text>
                                                    <Text style={styles.para}>{data?.schoolName}</Text>
                                                </View>
                                            }
                                        </View>
                                    </View>
                                ))}
                        </View>

                        <View style={{ ...styles.border }}>
                            <Text style={{ ...styles.mainHeading, fontSize: 10 }}>DIAGNOSIS & SEVERITY</Text>
                        </View>
                        <View style={{ marginBottom: 4, width: "100%" }} wrap={false}>
                            <PDFHtmlRenderer
                                style={{ fontSize: 8, ...styles.para, }}
                                data={feedbacks[TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.diagnosis]?.answer || ""}
                            />
                        </View>

                        <View wrap={false}>
                            <View style={{ ...styles.border, marginTop: 4 }}>
                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>BACKGROUND</Text>
                            </View>
                            <View style={{ marginBottom: 4, width: "100%" }}>
                                <PDFHtmlRenderer
                                    style={{ fontSize: 8, ...styles.para, }}
                                    data={feedbacks[TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.background]?.answer || ""}
                                />
                            </View>
                        </View>

                        <View wrap={false}>
                            <View style={{ ...styles.border, marginTop: 4 }}>
                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>ADDITIONAL INFORMATION</Text>
                            </View>
                            <View style={{ marginBottom: 4, width: "100%" }} >
                                <PDFHtmlRenderer
                                style={{ fontSize: 8, ...styles.para, }}
                                data={feedbacks[TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.additionalInformation]?.answer || ""}
                            />
                            </View>
                        </View>

                        {/* <View style={{ marginTop: "15px" }} wrap={false}>
                        <AnswerMultipleRecommendations
                            recommendations={reportRecommendations}
                            styles={styles}
                        />
                    </View> */}
                        <View style={{ marginTop: 10 }}>
                            {assessmentPlans?.length && assessmentPlans.map((assessment, index) => {
                                const summaryAttachments = assessment?.summary?.attachmentData;
                                const diagnosisAttachments = assessment?.diagnosis_severity?.attachmentData;
                                return (
                                    <>
                                        <View wrap={false} key={index}>
                                            {index === 0 && (
                                                <View style={{ ...styles.border }}>
                                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>ASSESSMENTS</Text>
                                                </View>
                                            )}
                                            <View style={{ ...styles.border, marginTop: 10 }}>
                                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>{dateFormat(assessment?.assessment_date, reportDateFormat)}</Text>
                                            </View>
                                            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", margin: "5px 0 5px", width: "100%", marginBottom: "10px" }}>
                                                <Text style={{ ...styles.mainSubHeading, fontSize: 10, textTransform: "uppercase" }}>
                                                    {assessment.title}
                                                </Text>
                                            </View>
                                            <PDFHtmlRenderer
                                                style={{ fontSize: 8, ...styles.para, }}
                                                data={assessment.answers}
                                            />
                                            {assessment.chartData && (
                                                <View>
                                                    <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: 5 }}>
                                                        <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>DETAILS</Text>
                                                    </View>
                                                    <View style={{ borderRadius: '4px' }}>
                                                        <AssessmentTableDataPDF
                                                            chartData={assessment.chartData}
                                                        />
                                                    </View>
                                                </View>
                                            )}
                                        </View>
                                        <View>
                                            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: "15px" }}>
                                                <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>ASSESSMENT SUMMARY</Text>
                                            </View>
                                            <View style={{ ...styles.flex, gap: 20, marginTop: 4 }}>
                                                <View style={{ width: "70%", paddingRight: 7 }}>
                                                    <PDFHtmlRenderer
                                                        style={{ fontSize: 8, ...styles?.para }}
                                                        data={assessment?.summary?.answer}
                                                    />
                                                </View>
                                                <View style={{ width: "30%" }}>
                                                    {summaryAttachments?.length && (
                                                        <View style={{ width: "100%" }}>
                                                            <View>
                                                                <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                                            </View>
                                                            {summaryAttachments?.map((item, index) => (
                                                                <View style={{ marginTop: '3px', ...styles.flex, gap: "2px", alignItems: "flex-start", }}>
                                                                    <Text style={{ ...styles.link, borderBottom: 0 }} >
                                                                        {index + 1}.
                                                                    </Text>
                                                                    <Link
                                                                        key={index}
                                                                        src={item?.attachment_name}
                                                                        style={styles.link}
                                                                    >
                                                                        {extractUploadFileName(item?.attachment_name)}
                                                                    </Link>
                                                                    {/* <Image style={{ width: 6 }} src={attachments_img} alt="attachment_img" /> */}
                                                                </View>
                                                            ))}
                                                        </View>
                                                    )}
                                                </View>
                                            </View>
                                        </View>

                                        <View>
                                            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: 10, width: "100%" }}>
                                                <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>ADDITIONAL INFORMATION</Text>
                                            </View>
                                            <View style={{ ...styles.flex, gap: 20, marginTop: 4 }}>
                                                <View style={{ width: "100%", paddingRight: 7 }}>
                                                    <PDFHtmlRenderer
                                                        style={{ fontSize: 8, ...styles.para }}
                                                        data={assessment?.additional_information?.answer}
                                                    />
                                                </View>
                                            </View>
                                        </View>

                                        <View>
                                            <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px", marginTop: "5px", width: "100%" }}>
                                                <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>DIAGNOSIS</Text>
                                            </View>
                                            <View style={{ ...styles.flex, gap: 20, marginTop: 4 }}>
                                                <View style={{ width: "100%", paddingRight: 7 }}>
                                                    <PDFHtmlRenderer
                                                        style={{ fontSize: 8, ...styles.para }}
                                                        data={assessment?.diagnosis_severity?.answer}
                                                    />
                                                </View>
                                                {/* <View style={{ width: "30%" }}>
                                                {diagnosisAttachments?.length && (
                                                    <View style={{ width: "100%" }}>
                                                        <View>
                                                            <Text style={styles.subHeading}>ATTACHMENTS</Text>
                                                        </View>
                                                        {diagnosisAttachments?.map((item, index) => (
                                                            <View style={{ marginTop: '3px', ...styles.flex, gap: "2px", alignItems: "flex-start" }}>
                                                                <Text style={{ ...styles.link, borderBottom: 0 }} >
                                                                    {index + 1}.
                                                                </Text>
                                                                <Link
                                                                    src={item?.attachment_name}
                                                                    style={styles.link}
                                                                >
                                                                    {extractUploadFileName(item?.attachment_name)}
                                                                </Link>
                                                            </View>
                                                        ))}
                                                    </View>
                                                )}
                                            </View> */}
                                            </View>
                                        </View>
                                    </>
                                )
                            })}
                        </View>

                         {
                            treatmentSummary?.length > 0 &&
                            <View style={{ marginTop: 10 }}>
                                <View style={{ ...styles.border }}>
                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>TREATMENT SUMMARY</Text>
                                </View>
                                <TreatmentSummarySection
                                    data={treatmentSummary}
                                    chartImages={data?.images}
                                    styles={styles}
                                />
                            </View>
                        }

                        {
                            treatmentPlans?.length > 0 &&
                            <View style={{ marginTop: 10 }}>
                                <View style={{ ...styles.border }}>
                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>TREATMENT PLAN</Text>
                                </View>
                                <TreatmentPlanSection
                                    data={treatmentPlans}
                                    // chartImages={data?.images}
                                    styles={styles}
                                />
                            </View>
                        }

                        <View style={{ marginTop: 10 }}>
                            <View wrap={false}>
                                <View style={{ ...styles.border }}>
                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>SUMMARY</Text>
                                </View>
                                <View style={{ width: "100%" }}>
                                    <PDFHtmlRenderer
                                        style={{ fontSize: 8, ...styles.para }}
                                        data={feedbacks[TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.summary]?.answer}
                                    />
                                </View>
                            </View>

                            <View style={{ marginTop: 10 }} wrap={false}>
                                <View style={{ ...styles.border }}>
                                    <Text style={{ ...styles.mainHeading, fontSize: 10 }}>CLINICAL IMPRESSIONS</Text>
                                </View>
                                <View style={{ width: "100%" }}>
                                    <PDFHtmlRenderer
                                        style={{ fontSize: 8, ...styles.para }}
                                        data={feedbacks[TREATMENT_SUMMARY_REPORT_V2_QUESTIONS.clinical_impressions]?.answer}
                                    />
                                </View>
                            </View>

                            <View style={{ marginTop: 10 }}>
                                <AnswerMultipleRecommendations
                                    styles={styles}
                                    fontSize={11}
                                    recommendations={reportRecommendations}
                                />
                            </View>
                        </View>
                        <View wrap={false} style={{ marginTop: 10, width: "40%" }}>
                            <View style={styles.border}>
                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>CLINICIAN INFORMATION</Text>
                            </View>
                            <View style={{ marginTop: "10px", ...styles.flex, gap: "12px" }}>
                                <View>
                                    <TherapistSignaturePdf
                                        data={data}
                                    />
                                </View>
                            </View>
                        </View>
                    </View>
                    {/* <View style={styles.footer}>
                    <View style={styles.border}></View>
                    <View>
                        <Text style={{ ...styles.para, ...styles.fontBold, alignItems: "flex-start" }}>
                            KHAN COMMUNICATION SERVICES
                        </Text>
                        <View style={{ ...styles.flex, justifyContent: "space-between", alignItems: "center", marginTop: "5px" }}>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={InstaIcons} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    @khancommservices
                                </Text>
                            </View>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={clickIcon} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    www.khancommunicationservices.com
                                </Text>
                            </View>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={callIcons} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    (780)-440-3251
                                </Text>
                            </View>
                        </View>
                    </View>
                </View> */}
                    <View style={{ height: 80 }} />
                </View>
                <PdfFooter data={data} />
            </Page>
        </Document>
    )
};

export default TreatmentSummaryReportDocV2;